export const Environment = {
  production: false,
  development: true,
  test: false,
  staging: false,
  local: false,
  apiUrl: "https://sigmasoftinfotech.com/tomcat/MasterConfiguration-0.0.1-SNAPSHOT/SSIT/MasterConfiguration",
  emsUrl: "https://sigmasoftinfotech.com/tomcat/EMSPortal-0.0.1-SNAPSHOT/SSIT/ems",
  emsUrlDuplicate: "https://sigmasoftinfotech.com/tomcat/EMSPortal-0.0.1-SNAPSHOT/ssit/ems",
  loginUrl: "https://sigmasoftinfotech.com/tomcat/usermanagement-0.0.1-SNAPSHOT",
  smartHireUrl: "https://sigmasoftinfotech.com/tomcat/smarthire-0.0.1-SNAPSHOT/api/candidate",
  microsoftLoginURL: "http://localhost:8089",
  loginScope: "api://540d854f-c10a-4072-a571-0446ed7d7826/usermanagement",
};
